import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=4bdd6c5f&"
import script from "./rule.vue?vue&type=script&lang=ts&"
export * from "./rule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports